(function () {
  var ENABLE_KEY = "agbNavigationDiagnostics";
  var CLICK_KEY = "agbNavigationDiagnosticsLastClick";
  var REPORT_KEY = "agbNavigationDiagnosticsReports";
  var params = new URLSearchParams(window.location.search);

  function safeJsonParse(value) {
    try {
      return JSON.parse(value || "null");
    } catch (error) {
      return null;
    }
  }

  window.AGBNavigationDiagnostics = window.AGBNavigationDiagnostics || {
    enable: function () {
      window.localStorage.setItem(ENABLE_KEY, "1");
      window.location.reload();
    },
    disable: function () {
      window.localStorage.removeItem(ENABLE_KEY);
      window.sessionStorage.removeItem(CLICK_KEY);
      window.location.reload();
    },
    getReports: function () {
      return safeJsonParse(window.localStorage.getItem(REPORT_KEY)) || [];
    },
    clearReports: function () {
      window.localStorage.removeItem(REPORT_KEY);
      window.sessionStorage.removeItem(CLICK_KEY);
    },
    status: function () {
      return {
        enabled: window.localStorage.getItem(ENABLE_KEY) === "1",
        reports: (safeJsonParse(window.localStorage.getItem(REPORT_KEY)) || []).length,
        hint: "Run AGBNavigationDiagnostics.enable() or visit ?agbdiag=1 to start logging."
      };
    }
  };

  if (params.get("agbdiag") === "1") {
    window.localStorage.setItem(ENABLE_KEY, "1");
  }

  if (params.get("agbdiag") === "0") {
    window.localStorage.removeItem(ENABLE_KEY);
    window.sessionStorage.removeItem(CLICK_KEY);
  }

  if (window.localStorage.getItem(ENABLE_KEY) !== "1") {
    return;
  }

  var startedAt = Date.now();
  var longTasks = [];
  var networkEvents = [];
  var browserErrors = [];

  function now() {
    return Math.round(performance.now());
  }

  function simplifyUrl(value) {
    try {
      var url = new URL(value, window.location.href);
      return url.hostname + url.pathname + url.search;
    } catch (error) {
      return String(value || "").slice(0, 160);
    }
  }

  function getNavigationTiming() {
    var entry = performance.getEntriesByType("navigation")[0];

    if (!entry) {
      return null;
    }

    return {
      type: entry.type,
      redirect: Math.round(entry.redirectEnd - entry.redirectStart),
      dns: Math.round(entry.domainLookupEnd - entry.domainLookupStart),
      connect: Math.round(entry.connectEnd - entry.connectStart),
      requestToFirstByte: Math.round(entry.responseStart - entry.requestStart),
      responseDownload: Math.round(entry.responseEnd - entry.responseStart),
      domInteractive: Math.round(entry.domInteractive),
      domContentLoaded: Math.round(entry.domContentLoadedEventEnd),
      load: Math.round(entry.loadEventEnd),
      transferSize: entry.transferSize || 0,
      encodedBodySize: entry.encodedBodySize || 0
    };
  }

  function getSlowResources() {
    return performance.getEntriesByType("resource")
      .filter(function (entry) {
        return entry.duration >= 750 || entry.name.indexOf("zoho") !== -1;
      })
      .sort(function (left, right) {
        return right.duration - left.duration;
      })
      .slice(0, 15)
      .map(function (entry) {
        return {
          ms: Math.round(entry.duration),
          type: entry.initiatorType,
          transferSize: entry.transferSize || 0,
          url: simplifyUrl(entry.name)
        };
      });
  }

  function addNetworkEvent(event) {
    event.capturedAt = new Date().toISOString();
    networkEvents.push(event);
    networkEvents = networkEvents.slice(-40);
  }

  function addBrowserError(event) {
    event.capturedAt = new Date().toISOString();
    browserErrors.push(event);
    browserErrors = browserErrors.slice(-40);
  }

  function saveReport(report) {
    var reports = safeJsonParse(window.localStorage.getItem(REPORT_KEY)) || [];
    reports.unshift(report);
    window.localStorage.setItem(REPORT_KEY, JSON.stringify(reports.slice(0, 12)));
  }

  function buildReport(label) {
    var lastClick = safeJsonParse(window.sessionStorage.getItem(CLICK_KEY));
    var sinceScriptStart = Date.now() - startedAt;
    var elapsedSinceClick = lastClick ? Date.now() - lastClick.timestamp : null;
    var navigationFromClick = elapsedSinceClick !== null ? Math.max(0, elapsedSinceClick - sinceScriptStart) : null;
    var report = {
      label: label,
      capturedAt: new Date().toISOString(),
      url: window.location.href,
      title: document.title,
      readyState: document.readyState,
      sinceScriptStartMs: sinceScriptStart,
      previousClick: lastClick,
      elapsedSincePreviousClickMs: elapsedSinceClick,
      navigationFromClickMs: navigationFromClick,
      navigation: getNavigationTiming(),
      slowResources: getSlowResources(),
      networkEvents: networkEvents.slice(-20),
      browserErrors: browserErrors.slice(-20),
      longTasks: longTasks.slice(-15)
    };

    saveReport(report);
    return report;
  }

  function logReport(label) {
    var report = buildReport(label);
    var slowNavigation = report.navigationFromClickMs && report.navigationFromClickMs > 2000;
    var method = slowNavigation ? "warn" : "log";

    if (!window.console) {
      return;
    }

    console.groupCollapsed(
      "%cAGB navigation diagnostics%c " + label + (slowNavigation ? " - slow navigation detected" : ""),
      "background:#0b2c4d;color:#fff;padding:2px 5px;border-radius:3px;",
      "color:inherit;"
    );
    console[method](report);
    if (report.navigation) {
      console.table([report.navigation]);
    }
    if (report.slowResources.length) {
      console.table(report.slowResources);
    }
    if (report.networkEvents.length) {
      console.table(report.networkEvents);
    }
    if (report.browserErrors.length) {
      console.table(report.browserErrors);
    }
    if (report.longTasks.length) {
      console.table(report.longTasks);
    }
    console.log("Saved reports:", REPORT_KEY, "Disable with ?agbdiag=0");
    console.groupEnd();
  }

  function installLongTaskObserver() {
    if (!("PerformanceObserver" in window)) {
      return;
    }

    try {
      var observer = new PerformanceObserver(function (list) {
        list.getEntries().forEach(function (entry) {
          var attribution = entry.attribution ? Array.prototype.slice.call(entry.attribution).map(function (item) {
            return {
              name: item.name || "",
              entryType: item.entryType || "",
              start: Math.round(item.startTime || 0),
              duration: Math.round(item.duration || 0),
              containerType: item.containerType || "",
              containerSrc: item.containerSrc ? simplifyUrl(item.containerSrc) : "",
              containerId: item.containerId || "",
              containerName: item.containerName || ""
            };
          }) : [];

          longTasks.push({
            start: Math.round(entry.startTime),
            duration: Math.round(entry.duration),
            name: entry.name || "longtask",
            attribution: attribution
          });
          longTasks = longTasks.slice(-40);
        });
      });
      observer.observe({ type: "longtask", buffered: true });
    } catch (error) {}
  }

  function installClickRecorder() {
    document.addEventListener("click", function (event) {
      var link = event.target && event.target.closest && event.target.closest("a[href]");

      if (!link || event.defaultPrevented || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) {
        return;
      }

      var href = link.getAttribute("href") || "";
      if (!href || href.charAt(0) === "#" || href.indexOf("javascript:") === 0 || href.indexOf("mailto:") === 0 || href.indexOf("tel:") === 0) {
        return;
      }

      window.sessionStorage.setItem(CLICK_KEY, JSON.stringify({
        timestamp: Date.now(),
        perfNow: now(),
        from: window.location.href,
        to: new URL(href, window.location.href).href,
        text: (link.textContent || "").trim().replace(/\s+/g, " ").slice(0, 120),
        classes: link.className || ""
      }));
    }, true);
  }

  function installNetworkRecorder() {
    if (window.fetch) {
      var originalFetch = window.fetch;
      window.fetch = function () {
        var args = arguments;
        var requestUrl = args[0] && args[0].url ? args[0].url : args[0];
        var started = Date.now();

        return originalFetch.apply(this, args).then(function (response) {
          if (!response.ok || Date.now() - started > 1000) {
            addNetworkEvent({
              api: "fetch",
              status: response.status,
              ok: response.ok,
              ms: Date.now() - started,
              url: simplifyUrl(response.url || requestUrl)
            });
          }
          return response;
        }).catch(function (error) {
          addNetworkEvent({
            api: "fetch",
            error: error && error.message ? error.message : String(error),
            ms: Date.now() - started,
            url: simplifyUrl(requestUrl)
          });
          throw error;
        });
      };
    }

    if (window.XMLHttpRequest && window.XMLHttpRequest.prototype) {
      var originalOpen = window.XMLHttpRequest.prototype.open;
      var originalSend = window.XMLHttpRequest.prototype.send;

      window.XMLHttpRequest.prototype.open = function (method, url) {
        this.__agbDiagnostics = {
          method: method,
          url: url,
          started: 0
        };
        return originalOpen.apply(this, arguments);
      };

      window.XMLHttpRequest.prototype.send = function () {
        var xhr = this;
        var details = xhr.__agbDiagnostics || {};
        details.started = Date.now();

        function record(type) {
          var status = 0;
          try {
            status = xhr.status;
          } catch (error) {}

          if (type === "error" || type === "timeout" || status >= 400 || Date.now() - details.started > 1000) {
            addNetworkEvent({
              api: "xhr",
              type: type,
              method: details.method,
              status: status,
              ms: Date.now() - details.started,
              url: simplifyUrl(details.url)
            });
          }
        }

        xhr.addEventListener("loadend", function () {
          record("loadend");
        });
        xhr.addEventListener("error", function () {
          record("error");
        });
        xhr.addEventListener("timeout", function () {
          record("timeout");
        });

        return originalSend.apply(this, arguments);
      };
    }
  }

  function installErrorRecorder() {
    window.addEventListener("error", function (event) {
      addBrowserError({
        type: "error",
        message: event.message || "",
        source: simplifyUrl(event.filename || ""),
        line: event.lineno || 0,
        column: event.colno || 0
      });
    });

    window.addEventListener("unhandledrejection", function (event) {
      var reason = event.reason || {};
      addBrowserError({
        type: "unhandledrejection",
        message: reason.message || String(reason),
        stack: reason.stack ? String(reason.stack).slice(0, 500) : ""
      });
    });
  }

  function installBadge() {
    function addBadge() {
      if (document.getElementById("agb-navigation-diagnostics-badge")) {
        return;
      }

      var badge = document.createElement("button");
      badge.id = "agb-navigation-diagnostics-badge";
      badge.type = "button";
      badge.textContent = "AGB diag";
      badge.title = "Navigation diagnostics are on. Click to print a report.";
      badge.style.cssText = [
        "position:fixed",
        "left:10px",
        "bottom:10px",
        "z-index:2147483647",
        "border:0",
        "border-radius:4px",
        "background:#0b2c4d",
        "color:#fff",
        "font:700 11px/1 Arial,sans-serif",
        "padding:7px 9px",
        "box-shadow:0 2px 10px rgba(0,0,0,.18)",
        "cursor:pointer"
      ].join(";");
      badge.addEventListener("click", function () {
        logReport("manual");
      });
      document.body.appendChild(badge);
    }

    if (document.readyState === "loading") {
      document.addEventListener("DOMContentLoaded", addBadge);
    } else {
      addBadge();
    }
  }

  window.AGBNavigationDiagnostics = {
    enable: function () {
      window.localStorage.setItem(ENABLE_KEY, "1");
      window.location.reload();
    },
    report: function () {
      logReport("manual");
    },
    getReports: function () {
      return safeJsonParse(window.localStorage.getItem(REPORT_KEY)) || [];
    },
    clearReports: function () {
      window.localStorage.removeItem(REPORT_KEY);
      window.sessionStorage.removeItem(CLICK_KEY);
    },
    disable: function () {
      window.localStorage.removeItem(ENABLE_KEY);
      window.sessionStorage.removeItem(CLICK_KEY);
      window.location.reload();
    },
    status: function () {
      return {
        enabled: true,
        reports: (safeJsonParse(window.localStorage.getItem(REPORT_KEY)) || []).length,
        hint: "Logging is active. Click links normally and check AGBNavigationDiagnostics.getReports()."
      };
    }
  };

  installLongTaskObserver();
  installNetworkRecorder();
  installErrorRecorder();
  installClickRecorder();
  installBadge();

  window.addEventListener("pageshow", function () {
    window.setTimeout(function () {
      logReport("pageshow+1200ms");
    }, 1200);
    window.setTimeout(function () {
      logReport("pageshow+5000ms");
    }, 5000);
  });
})();
